import React, {useMemo} from "react"
import {ConfigProvider} from "antd"
import {observer} from "mobx-react"
import enUS from "antd/es/locale/en_US"
import esES from "antd/es/locale/es_ES"
import {useModel} from "hooks"
import {store} from "helpers"
import {getAntdDatePickerLocale} from "helpers/antdWeekStart"
import {Auth} from "types/auth"

type AntdConfigProviderProps = {
    children: React.ReactNode
}

export const AntdConfigProvider = observer(function AntdConfigProvider({children}: AntdConfigProviderProps) {
    const model = useModel()
    const startWeekOn = model.getStartWeekOn()
    const isSpanish = (store.get("locale") || Auth.DisplayLanguage.English) === Auth.DisplayLanguage.Spanish

    const antdLocale = useMemo(
        () => ({
            ...(isSpanish ? esES : enUS),
            DatePicker: getAntdDatePickerLocale(startWeekOn)
        }),
        [isSpanish, startWeekOn]
    )

    return <ConfigProvider locale={antdLocale}>{children}</ConfigProvider>
})
